<div class="row page-header">
    <div class="col-12">
        <h1>Phase Costs <small>Select Job Types, Cost Types, Jobs, and Phases to view estimates vs actuals</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-2">
            <h4 style="text-align: center; color: rgb(105, 120, 130); padding: 3px 0 2px 0">Filters</h4>

            <label for="selectedProjectTypes">Selected Job Types</label>
            <wj-multi-select
                id="selectedProjectTypes"
                name="selectedProjectTypes"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedProjectTypes"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [placeholder]="'Select Job Types'"
                [headerFormat]="'{count:n0} items'"
                [itemsSource]="projectTypesMap"
                (ngModelChange)="onProjectTypesChanged()"
            >
            </wj-multi-select>

            <label for="selectedJobStatus">Job Status</label>
            <wj-multi-select
                id="selectedJobStatus"
                name="selectedJobStatus"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedJobStatus"
                [showSelectAllCheckbox]="true"
                [placeholder]="'Select Job Status'"
                [headerFormat]="'{count:n0} items'"
                [itemsSource]="jobStatusList"
                [displayMemberPath]="'display'"
                (ngModelChange)="onProjectTypesChanged()"
            ></wj-multi-select>

            <label for="years">Jobs in Past X Years (only applies to Closed Jobs)</label>
            <input
                type="number"
                id="years"
                class="form-control"
                style="margin-bottom: 10px"
                [(ngModel)]="years"
                name="years"
                (ngModelChange)="onProjectTypesChanged()"
            />

            <label for="minCost">Min Total Job Actual Cost</label>
            <input
                type="number"
                id="minCost"
                class="form-control"
                style="margin-bottom: 10px"
                max="999999999"
                min="0"
                [(ngModel)]="minCost"
                name="minCost"
                (ngModelChange)="onProjectTypesChanged()"
            />

            <label for="maxCost">Max Total Job Actual Cost</label>
            <input
                type="number"
                id="maxCost"
                class="form-control"
                style="margin-bottom: 10px"
                max="999999999"
                min="0"
                [(ngModel)]="maxCost"
                name="maxCost"
                (ngModelChange)="onProjectTypesChanged()"
            />

            <label for="selectedJobs">Selected Jobs</label>
            <wj-multi-select
                id="selectedJobs"
                name="selectedJobs"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedJobs"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [placeholder]="'Select Jobs'"
                [headerFormat]="'{count:n0} items'"
                [itemsSource]="jobsMap"
                (ngModelChange)="onJobsChanged()"
            >
            </wj-multi-select>
            <label for="selectedCostTypes">Selected Cost Types</label>
            <wj-multi-select
                id="selectedCostTypes"
                name="selectedCostTypes"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedCostTypes"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [placeholder]="'Select Cost Types'"
                [headerFormat]="'{count:n0} items'"
                [itemsSource]="costTypesMap"
            >
            </wj-multi-select>
            <label for="selectedPhaseType">Selected Phase Types</label>
            <wj-combo-box
                id="selectedPhaseType"
                name="selectedPhaseType"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedPhaseType"
                [itemsSource]="phaseTypeMap"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [isRequired]="true"
                (ngModelChange)="onJobsChanged()"
            >
            </wj-combo-box>
            <label for="selectedPhases">Selected {{ selectedPhaseType === 0 ? 'Phases' : 'Activities' }}</label>
            <wj-multi-select
                id="selectedPhases"
                name="selectedPhases"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedPhases"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [placeholder]="selectedPhaseType === 0 ? 'Phases' : 'Activities'"
                [headerFormat]="'{count:n0} items'"
                [itemsSource]="selectedPhaseType === 0 ? phasesMap : activitiesMap"
                (ngModelChange)="onPhasesChanged()"
            >
            </wj-multi-select>
            <label for="selectedReportGroup">Results Grouping</label>
            <wj-combo-box
                id="selectedReportGroup"
                name="selectedReportGroup"
                style="width: 100%; margin-bottom: 10px"
                [(ngModel)]="selectedReportGroup"
                [itemsSource]="reportGroup"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [isRequired]="true"
                (ngModelChange)="clearGrids()"
            >
            </wj-combo-box>

            <button type="button" class="btn btn-sm btn-secondary" style="width: 100%; margin-bottom: 10px" (click)="getPhaseCostData()">
                Get Summarized Report
            </button>
            <button type="button" class="btn btn-sm btn-secondary" style="width: 100%; margin-bottom: 10px" (click)="getRawPhaseCostData()">
                Get Raw Data Results
            </button>
        </div>
        <div class="col-lg-10">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1" [destroyOnHide]="false">
                    <a ngbNavLink>Costs By Job/Phase</a>
                    <ng-template ngbNavContent>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="grid" [hidden]="!showSummary"></action-toolbar-count>
                                    <action-toolbar-count [grid]="rawGrid" [hidden]="showSummary"></action-toolbar-count>
                                    <!--<action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>-->
                                    <grid-export [grid]="mainGrid" [name]="'Phase Costs'" [hidden]="!showSummary"></grid-export>
                                    <grid-export [grid]="gridRaw" [name]="'Raw Phase Cost Data'" [hidden]="showSummary"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row" [hidden]="!showSummary">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="mainGrid"
                                    #mainGrid
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="grid.initialize(mainGrid)"
                                    (destroy)="grid.destroy()"
                                    [itemFormatter]="itemFormatter"
                                    [itemsSource]="grid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="selectedReportGroup === 0 ? 'Job' : 'Phase'"
                                        [binding]="selectedReportGroup === 0 ? 'job' : 'phase'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Hours'"
                                        [binding]="'actualHours'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Est Hours'"
                                        [binding]="'estHours'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hours Variance'"
                                        [binding]="'hoursVariance'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hours % Used'"
                                        [binding]="'hoursPercentUsed'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Cost'"
                                        [binding]="'actualCost'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Est Cost'"
                                        [binding]="'estCost'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Cost Variance'"
                                        [binding]="'costVariance'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Cost %Used'"
                                        [binding]="'costPercentUsed'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                            </div>
                        </div>
                        <div class="row" [hidden]="showSummary">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridRaw"
                                    #gridRaw
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="rawGrid.initialize(gridRaw)"
                                    (destroy)="rawGrid.destroy()"
                                    [itemsSource]="rawGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridRaw"></grid-selection-calculation>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" [destroyOnHide]="false">
                    <a ngbNavLink>Cost Type Ratios</a>
                    <ng-template ngbNavContent>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="ratioGrid" [hidden]="!showSummary"></action-toolbar-count>
                                    <grid-export [grid]="gridRatio" [name]="'Phase Costs'" [hidden]="!showSummary"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row" [hidden]="!showSummary">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridRatio"
                                    #gridRatio
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="ratioGrid.initialize(gridRatio)"
                                    (destroy)="ratioGrid.destroy()"
                                    [itemFormatter]="itemFormatter"
                                    [itemsSource]="ratioGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="selectedReportGroup === 0 ? 'Job' : 'Phase'"
                                        [binding]="selectedReportGroup === 0 ? 'job' : 'phase'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'10 - Labor'"
                                        [binding]="'labor10'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'20 - Material Perm'"
                                        [binding]="'materialPerm20'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'21 - Materlials Con'"
                                        [binding]="'materlials21'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'30 - Equip Alloc'"
                                        [binding]="'equipAlloc30'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'31 - Rented Equip'"
                                        [binding]="'rentedEquip31'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'40 - Sub Contractor'"
                                        [binding]="'subContractor40'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'50 - Other'"
                                        [binding]="'other50'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'60 - Overhead'"
                                        [binding]="'overhead60'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'90 - Fab/Shop'"
                                        [binding]="'fabShop90'"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridRatio"></grid-selection-calculation>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>
</div>
